import { render, staticRenderFns } from "./ListTitle.vue?vue&type=template&id=621ac045&scoped=true&"
import script from "./ListTitle.vue?vue&type=script&lang=js&"
export * from "./ListTitle.vue?vue&type=script&lang=js&"
import style0 from "./ListTitle.vue?vue&type=style&index=0&id=621ac045&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ac045",
  null
  
)

export default component.exports